/* lm-cart.js — cart drawer behaviour.
   Class-driven open/close, event delegation on the persistent overlay (survives re-renders),
   quantity steppers + removal via Shopify's AJAX cart API (/cart/change.js), smooth collapse-out,
   graceful empty state, inline errors (no alert), Esc-to-close + focus handling, live bag count.
   Exposes window.updateCartDrawer(open) for the product page's add-to-cart. */
(function () {
  'use strict';

  var overlay = document.getElementById('lm-cart-overlay');
  if (!overlay) return;
  var lastFocus = null;
  var syncing = false;

  var drawer = function () { return document.getElementById('lm-cart-drawer'); };

  function openCart() {
    lastFocus = document.activeElement;
    overlay.classList.add('is-open');
    overlay.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    var c = overlay.querySelector('[data-cart-close]');
    if (c) c.focus({ preventScroll: true });
  }
  function closeCart() {
    overlay.classList.remove('is-open');
    overlay.setAttribute('aria-hidden', 'true');
    document.documentElement.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  window.lmOpenCart = openCart;
  window.lmCloseCart = closeCart;

  function showError(msg) {
    var e = overlay.querySelector('[data-cart-error]');
    if (e) { e.textContent = msg; e.hidden = false; }
  }
  function setBusy(on) { syncing = on; overlay.classList.toggle('is-busy', !!on); }

  async function refresh() {
    try {
      var res = await fetch('/?section_id=lm-cart');
      if (!res.ok) throw new Error('section fetch failed');
      var tmp = document.createElement('div');
      tmp.innerHTML = await res.text();
      var fresh = tmp.querySelector('#lm-cart-drawer');
      var cur = drawer();
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
      updateBagCount();
    } catch (err) {
      showError('Something went wrong updating your cart. Please refresh and try again.');
    }
  }

  // called by the product page after /cart/add.js — refresh in place (the product page shows its
  // own "added to bag" notice; pass true to also reveal the drawer).
  window.updateCartDrawer = async function (open) {
    await refresh();
    if (open === true) openCart();
  };

  async function cartChange(key, qty) {
    if (syncing) return;
    setBusy(true);
    try {
      var res = await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      });
      if (!res.ok) throw new Error('change failed');
      await refresh();
    } catch (err) {
      showError('We couldn’t update that item. Please try again.');
      await refresh(); // re-sync to the server's truth
    } finally {
      setBusy(false);
    }
  }

  async function removeItem(key, itemEl) {
    if (itemEl) {
      itemEl.style.maxHeight = itemEl.scrollHeight + 'px';
      itemEl.style.overflow = 'hidden';
      void itemEl.offsetHeight; // reflow so the transition has a start value
      itemEl.style.opacity = '0';
      itemEl.style.maxHeight = '0px';
      itemEl.style.marginBottom = '0px';
      await new Promise(function (r) { setTimeout(r, 400); });
    }
    await cartChange(key, 0);
  }

  function updateBagCount() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) {
      var bag = document.getElementById('open-cart-btn');
      if (bag) bag.textContent = c.item_count > 0 ? 'bag (' + c.item_count + ')' : 'bag';
    }).catch(function () {});
  }

  // one delegated handler on the persistent overlay — no re-binding after re-render
  overlay.addEventListener('click', function (e) {
    if (e.target === overlay) { closeCart(); return; }
    var t = e.target.closest('[data-cart-close],[data-cart-remove],[data-qty-up],[data-qty-down]');
    if (!t) return;
    e.stopPropagation();
    var itemEl = t.closest('[data-cart-item]');
    var key = itemEl ? itemEl.getAttribute('data-key') : null;

    if (t.hasAttribute('data-cart-close')) { closeCart(); return; }
    if (syncing) return;
    if (t.hasAttribute('data-cart-remove')) { removeItem(key, itemEl); return; }
    var qEl = itemEl && itemEl.querySelector('[data-qty]');
    if (!qEl) return;
    var cur = parseInt(qEl.textContent, 10) || 1;
    var next = t.hasAttribute('data-qty-up') ? cur + 1 : cur - 1;
    if (next < 1) { removeItem(key, itemEl); return; }
    qEl.textContent = next; // optimistic
    cartChange(key, next);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeCart();
  });

  function boot() {
    var btn = document.getElementById('open-cart-btn');
    if (btn) btn.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
    updateBagCount();
  }
  if (document.readyState !== 'loading') boot();
  else document.addEventListener('DOMContentLoaded', boot);
})();
